'use client';

import Image from 'next/image';
import styled from 'styled-components';
import {
  getCardTypeByType,
  getCardTypeByValue,
  PLACEHOLDER,
} from './cardTypes';

const StyledCcInfo = styled.span`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const removeSpaces = (str: string) => str.replace(/\s/g, '');

export function DisplayCreditCard({
  lastFour,
  brand,
  showIcon = true,
  children,
}: {
  lastFour?: string;
  brand?: string;
  showIcon?: boolean;
  children?: string;
}) {
  const cleanChildren = children ? removeSpaces(children) : '';
  const cardType = brand
    ? (getCardTypeByType(brand) ?? PLACEHOLDER)
    : getCardTypeByValue(cleanChildren);

  const cardIconPath = `//assets.asurion-ui.my.asurion53.com/images/badges/payment/${cardType.type}.svg`;
  const gaps = cardType.gaps ?? [];

  let maskedNumber = cleanChildren.slice(0, -4);
  let gapIndex = 0;

  if (gaps.length) {
    for (let gapPosition of gaps) {
      if (maskedNumber.length >= gapPosition + gapIndex) {
        maskedNumber =
          maskedNumber.slice(0, gapPosition + gapIndex) +
          ' ' +
          maskedNumber.slice(gapPosition + gapIndex);
        gapIndex++;
      }
    }
  }

  maskedNumber =
    maskedNumber.replace(/\d/g, '*') + ' ' + cleanChildren.slice(-4);

  return (
    <div className="overflow-x-auto">
      <StyledCcInfo className="fs-mask">
        {showIcon && (
          <Image
            src={cardIconPath}
            width={38}
            height={24}
            alt={`${cardType.displayName} Icon`}
          />
        )}
        {cleanChildren ? maskedNumber : `Ending with ${lastFour}`}
      </StyledCcInfo>
    </div>
  );
}
